export const LOAD_ACTIVE_CONVERSATION = "LOAD_ACTIVE_CONVERSATION";
export const loadActiveConversationAC = () => ({
    type: LOAD_ACTIVE_CONVERSATION,
});